import React from "react";
import TextAction from "./TextAction";
import {
  INK_SECONDARY,
  OVERLAY_SHADOW,
  neutralText,
  stopPropagation,
} from "./layerStyle";

/**
 * 「底圖已全部關閉 · 恢復」, centred over a plane canvas once 平面圖 is off
 * and no map is showing, so an empty canvas never reads as "nothing loaded".
 * 恢復 turns 平面圖 back on. Markers still draw on top of it.
 */
const BlankCanvasHint = ({ layers }) => {
  if (!layers?.hasPlan || layers.planVisible || layers.mapVisible) return null;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <div
        onMouseDown={stopPropagation}
        onClick={stopPropagation}
        style={{
          ...neutralText,
          color: INK_SECONDARY,
          display: "flex",
          gap: 10,
          padding: "4px 12px",
          borderRadius: 4,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          boxShadow: OVERLAY_SHADOW,
          pointerEvents: "auto",
        }}
      >
        <span>底圖已全部關閉</span>
        <TextAction onClick={layers.showPlan}>恢復</TextAction>
      </div>
    </div>
  );
};

export default BlankCanvasHint;
